import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
  min-height: 0;
  height: 100%;
`;

export const Title = styled.h1`
  color: #181818;
  font-size: 24px;
  font-weight: 600;
  line-height: 32px;
`;

export const ContentScroller = styled.div.attrs({
  "data-testid": "content-scroll",
} as Record<string, string>)`
  min-height: 0;
  flex: 1 1 auto;
  overflow: auto;
  padding-right: 16px;
`;

export const RowIcon = styled.span`
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: 4px;
  color: #7c7f7e;
  transition: color 0.2s ease;

  & i {
    font-size: 13px;
  }

  &:hover {
    color: #065fa6;
  }
`;

export const OrderNameCell = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  white-space: normal;
  max-width: 360px;
`;

export const ClickHint = styled.span`
  color: #005fb8;
  font-size: 14px;
  line-height: 1;
`;
